import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import LeadList from './pages/leads/LeadList';
import CreateLead from './pages/leads/CreateLead';
import LeadDetail from './pages/leads/LeadDetail';
import ClientList from './pages/clients/ClientList';
import ClientDetail from './pages/clients/ClientDetail';
import ClientApproval from './pages/clients/ClientApproval';
import OfficerReturnedClients from './pages/clients/OfficerReturnedClients';
import ClientOnboarding from './pages/clients/ClientOnboarding';
import LoanApplicationList from './pages/loans/LoanApplicationList';
import CreateLoanApplication from './pages/loans/CreateLoanApplication';
import LoanDetail from './pages/loans/LoanDetail';
import LoanProducts from './pages/loans/LoanProducts';
import LoanReview from './pages/loans/LoanReview';
import DisbursementHistory from './pages/loans/DisbursementHistory';
import RecordRepayment from './pages/repayments/RecordRepayment';
import RepaymentHistory from './pages/repayments/RepaymentHistory';
import CollectionDashboard from './pages/collections/CollectionDashboard';
import CollectionPerformance from './pages/collections/CollectionPerformance';
import CommunicationLog from './pages/communications/CommunicationLog';
import InteractionsPage from './pages/communications/InteractionsPage';
import UserManagement from './pages/admin/UserManagement';
import BranchManagement from './pages/admin/BranchManagement';
import RoleManagement from './pages/admin/RoleManagement';
import AuditLogs from './pages/admin/AuditLogs';
import Reports from './pages/reports/Reports';
import MpesaTransactions from './pages/mpesa/MpesaTransactions';
import MpesaCodeLinking from './pages/mpesa/MpesaCodeLinking';
import NotFound from './pages/NotFound';
import './App.css';

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />

      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="profile" element={<Profile />} />

        <Route path="leads" element={<LeadList />} />
        <Route path="leads/new" element={<CreateLead />} />
        <Route path="leads/:id" element={<LeadDetail />} />
        <Route path="clients" element={<ClientList />} />
        <Route path="/clients/onboard/:leadId" element={<ClientOnboarding />} />
        <Route path="clients/approvals" element={<ClientApproval />} />
        <Route path="clients/returned" element={<OfficerReturnedClients />} />
        <Route path="clients/:id" element={<ClientDetail />} />

        {/* ✅ UPDATED: Loan routes with review and disbursement history */}
        <Route path="loans/applications" element={<LoanApplicationList />} />
        <Route path="loans/applications/new" element={<CreateLoanApplication />} />
        <Route path="loans/applications/:id/review" element={<LoanReview />} />
        <Route path="loans/disbursements" element={<DisbursementHistory />} />
        <Route path="loans/active" element={<LoanDetail isList />} />
        <Route path="loans/:id" element={<LoanDetail />} />
        <Route path="products" element={<LoanProducts />} />

        <Route path="repayments/new" element={<RecordRepayment />} />
        <Route path="repayments/history" element={<RepaymentHistory />} />
        <Route path="collections" element={<CollectionDashboard />} />
        <Route path="collections/performance" element={<CollectionPerformance />} />
        <Route path="communications" element={<CommunicationLog />} />
        <Route path="/communications/interactions" element={<InteractionsPage />} />
        <Route path="admin/users" element={<UserManagement />} />
        <Route path="admin/branches" element={<BranchManagement />} />
        <Route path="admin/roles" element={<RoleManagement />} />
        <Route path="admin/audit-logs" element={<AuditLogs />} />
        <Route path="reports" element={<Reports />} />
        // In your App.js or router file:
        <Route path="/loans/active" element={<LoanDetail isList={true} />} />
        <Route path="/loans/closed" element={<LoanDetail isClosedList={true} />} />
        <Route path="/loans/:id" element={<LoanDetail />} />
        {/* M-Pesa Transactions Module */}
        <Route path="mpesa" element={<MpesaTransactions />} />
        <Route path="mpesa/link-code" element={<MpesaCodeLinking />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <AppRoutes />
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}